import React, { useState } from "react";

export default function EcommerceFulfillment() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider3.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 50px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(12px);
          padding: 40px;
          border-radius: 22px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease;
          margin-bottom: 60px;
        }

        .title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 90px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.9;
          margin-bottom: 18px;
        }

        .feature-box {
          padding: 22px;
          border-radius: 15px;
          background: white;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          border-left: 6px solid #005eff;
          margin-bottom: 20px;
        }

        .shipping-form {
          background: white;
          padding: 45px;
          border-radius: 20px;
          box-shadow: 0px 18px 40px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.06);
          animation: fadeUp 1s ease;
          margin-top: 70px;
        }

        .form-label {
          font-weight: 600;
          margin-bottom: 6px;
          color: #2b2b2b;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: 0.25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
          outline: none;
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 14px;
          transition: 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0,94,255,0.35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        .faq-box {
          background: #f4f6ff;
          padding: 18px;
          border-radius: 12px;
          margin-bottom: 12px;
          border-left: 4px solid #005eff;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>E-Commerce Fulfillment</h1>
      </div>

      {/* ⭐ MAIN SECTION */}
      <section className="section">
        <div className="container">

          {/* ⭐ OVERVIEW */}
          <div className="glass-card">
            <h2 className="title">Fast, Accurate & Scalable Fulfillment for Modern E-Commerce Brands</h2>

            <p className="text">
              In today’s ultra-competitive e-commerce world, customers expect fast delivery, 
              error-free packaging, real-time tracking, and reliable returns processing — 
              every single time.  
              SWIFTSHIP’s E-Commerce Fulfillment Network is built to help growing brands scale 
              effortlessly with Amazon-level speed and accuracy.
            </p>

            <p className="text">
              Whether you’re shipping 10 orders a day or 10,000+, our fulfillment centers are 
              equipped with advanced automation, optimized picking systems, real-time inventory 
              management, custom packaging capabilities, and a global carrier network to deliver the 
              seamless customer experience your business deserves.
            </p>

            <p className="text">
              We integrate with all major e-commerce platforms — Shopify, Amazon, Etsy, WooCommerce, 
              Walmart, eBay, Squarespace, and more — so your orders flow directly to our warehouse, 
              get picked, packed, and shipped on the same day.
            </p>
          </div>

          {/* ⭐ FEATURES */}
          <h2 className="title">What Our Fulfillment Service Includes</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Real-Time Inventory Management</h5>
            <p className="text">
              Track every SKU in real time with instant updates, automated stock alerts, 
              analytics, and low-stock notifications.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Same-Day Order Processing</h5>
            <p className="text">
              Orders received before cut-off time are packed & shipped the same day, ensuring 
              fast delivery and higher customer satisfaction.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Multi-Channel Integration</h5>
            <p className="text">
              We automatically sync with Shopify, Amazon, Walmart, Etsy, WooCommerce and 40+ 
              marketplaces for seamless order flow.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Custom Packaging Options</h5>
            <p className="text">
              Branded boxes, inserts, thank-you cards, fragile handling, subscription kits — 
              all available at scale.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Accurate Pick, Pack & QA System</h5>
            <p className="text">
              Our smart picking technology and double-verification process ensures 99.9% accuracy 
              in all shipments.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Affordable Carrier Rates</h5>
            <p className="text">
              Save up to 40% on USPS, UPS, FedEx & DHL rates with our volume shipping discounts.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Returns Management</h5>
            <p className="text">
              Streamlined RMA processing, inspection, restocking, or disposal — handled by our 
              fulfillment experts.
            </p>
          </div>

          {/* ⭐ INDUSTRIES */}
          <h2 className="title mt-5">Perfect for All E-Commerce Businesses</h2>

          <ul className="text">
            <li>✔ Beauty & Cosmetics</li>
            <li>✔ Apparel & Fashion Brands</li>
            <li>✔ Pet Supplies</li>
            <li>✔ Electronics & Accessories</li>
            <li>✔ Supplements & Nutrition</li>
            <li>✔ Home & Lifestyle Products</li>
            <li>✔ Subscription Boxes</li>
            <li>✔ DTC (Direct-to-Consumer) Brands</li>
          </ul>

          {/* ⭐ FAQ */}
          <h2 className="title mt-5">Frequently Asked Questions</h2>

          <div className="faq-box">
            <strong>Q: Do you integrate with Shopify & Amazon?</strong>
            <p className="text">Yes! Integration takes less than 5 minutes.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can you handle custom branded packaging?</strong>
            <p className="text">Absolutely — custom inserts, boxes, labels, and more.</p>
          </div>

          <div className="faq-box">
            <strong>Q: What is your order cut-off time?</strong>
            <p className="text">Orders placed before 2 PM ship the same day.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can you handle large SKU counts?</strong>
            <p className="text">Yes — we support thousands of SKUs with advanced inventory systems.</p>
          </div>

          {/* ⭐ PREMIUM FORM */}
          <form className="shipping-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request an E-Commerce Fulfillment Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Monthly Order Volume</label>
                <select className="form-select-custom" required>
                  <option value="">Select Volume</option>
                  <option>1 – 100 Orders</option>
                  <option>100 – 500 Orders</option>
                  <option>500 – 2,000 Orders</option>
                  <option>2,000 – 10,000 Orders</option>
                  <option>10,000+ Orders</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Storage Needed (Approx.)</label>
                <select className="form-select-custom" required>
                  <option value="">Select Storage</option>
                  <option>Small (1–5 pallets)</option>
                  <option>Medium (5–25 pallets)</option>
                  <option>Large (25–100 pallets)</option>
                  <option>Extra Large (100+ pallets)</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">E-Commerce Platform</label>
                <select className="form-select-custom">
                  <option>Shopify</option>
                  <option>Amazon FBA/FBM</option>
                  <option>Etsy</option>
                  <option>WooCommerce</option>
                  <option>Walmart</option>
                  <option>eBay</option>
                  <option>Custom Website</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Product Description (What You Sell)</label>
                <textarea className="form-control-custom" rows="4" required></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your request has been submitted successfully!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
